module.exports = __webpack_public_path__ + "static/img/avatar-default.1acab4b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar-default.png
// module id = I0uQ
// module chunks = 7